import React from 'react';
import { Facebook, Twitter, Instagram, Send } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-white font-semibold mb-4">Team Name Generators</h3>
            <ul className="space-y-2">
              <li><Link to="/sports" className="hover:text-white transition-colors">Sports Teams</Link></li>
              <li><Link to="/basketball" className="hover:text-white transition-colors">Basketball Teams</Link></li>
              <li><Link to="/fantasy-football" className="hover:text-white transition-colors">Fantasy Football</Link></li>
              <li><Link to="/superhero" className="hover:text-white transition-colors">Superhero Teams</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Business Generators</h3>
            <ul className="space-y-2">
              <li><Link to="/bar" className="hover:text-white transition-colors">Bar Names</Link></li>
              <li><Link to="/book" className="hover:text-white transition-colors">Book Titles</Link></li>
              <li><Link to="/acronym" className="hover:text-white transition-colors">Acronym Generator</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">SEO Tools</h3>
            <ul className="space-y-2">
              <li><Link to="/meta" className="hover:text-white transition-colors">Meta Title Generator</Link></li>
              <li><Link to="/youtube-tags" className="hover:text-white transition-colors">YouTube Tags</Link></li>
              <li><Link to="/html" className="hover:text-white transition-colors">HTML Generator</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Terms of Service</a></li>
              <li><a href="#" className="hover:text-white transition-colors">FAQs</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p>&copy; {new Date().getFullYear()} name-generators.ai. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}